import DEVELOPMENT_CONFIG from "../helper/config";
import axios from "axios";
import FormData from "form-data"
import { Encrption } from '../app-modules/encrption';

export default {
  postRequest: function (url, data, returnResultDataOnly = false) {
    if (!returnResultDataOnly) returnResultDataOnly = false;
    const token = localStorage.getItem("token");
    var config = {
      method: "post",
      url: DEVELOPMENT_CONFIG.base_url + url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return new Promise((resolve, reject) => {
      axios(config)
        .then(function (response) {
          if (response.data.statusCode === DEVELOPMENT_CONFIG.statusCode && response.data.status == true) {
            if (returnResultDataOnly === true) {
              resolve(response.data.resultData);
            }
            else
              resolve(response.data);
          } else {
            reject(response.data.message);
          }
        })
        .catch(function (error) {
          if (error.response.status == DEVELOPMENT_CONFIG.unAuthorized) {
            localStorage.clear();
            window.location.href = "/login";
          }
          else if(error?.response?.data?.Message){
            reject(error?.response?.data?.Message);
          } else {
            reject(error.message);
          }
        });
    });
  },


  multipartPostRequest: function (url, data, dontUseUTF8) {
    const token = localStorage.getItem('token');
    const formData = new FormData()
    for (const key in data) {
      const value = data[key]
      if (Array.isArray(value)) {
        for (const item of value)
          formData.append(key, item)
      } else {
        formData.append(key, value)
      }
    }
    var config = {
      method: 'post',
      url: DEVELOPMENT_CONFIG.base_url + url,
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': dontUseUTF8 ? 'multipart/form-data' : 'multipart/form-data;charset=UTF-8'
      },
      data: formData
    };
    return new Promise((resolve, reject) => {
      axios(config)
        .then(function (response) {
          if (response.data.statusCode === DEVELOPMENT_CONFIG.statusCode) {
            resolve(response.data);
          } else {
            reject(response.data.message);
          }
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            localStorage.clear();
            window.location.href = "/login";
          } else {
            reject(error);
          }
        });
    });
  },

  queryGetRequestWithEncryption: function (url, encryptParam1, param2, encryptParam2, data, returnResultDataOnly = false) {
    return this.getRequest(url
      + Encrption(encryptParam1)
      + (param2 ? param2 : "")
      + (encryptParam2 ? Encrption(encryptParam2) : ""),
      data, returnResultDataOnly)
  },

  getRequest: function (url, data, returnResultDataOnly = false) {
    if (!returnResultDataOnly) returnResultDataOnly = false;
    const token = localStorage.getItem("token");
    var config = {
      method: "get",
      url: DEVELOPMENT_CONFIG.base_url + url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return new Promise((resolve, reject) => {
      axios(config)
        .then(function (response) {
          if (response.data.statusCode === DEVELOPMENT_CONFIG.statusCode) {
            if (returnResultDataOnly === true)
              resolve(response.data.resultData);
            else
              resolve(response.data);

          } else {
            reject(response.data);
          }
        })
        .catch(function (error) {
          if (error.response.status == DEVELOPMENT_CONFIG.unAuthorized) {
            localStorage.clear();
            window.location.href = "/login";
          } else {
            reject(error);
          }
        });
    });
  },

  deleteRequestWithEncryption: function (url, encryptParam1, data, returnResultDataOnly = false) {
    return this.deleteRequest(url + Encrption(encryptParam1), data, returnResultDataOnly)
  },

  deleteRequest: function (url, data, returnResultDataOnly = false) {
    if (!returnResultDataOnly) returnResultDataOnly = false;
    const token = localStorage.getItem("token");
    var config = {
      method: "delete",
      url: DEVELOPMENT_CONFIG.base_url + url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return new Promise((resolve, reject) => {
      axios(config)
        .then(function (response) {
          if (response.data.statusCode === DEVELOPMENT_CONFIG.statusCode) {
            if (returnResultDataOnly === true)
              resolve(response.data.resultData);
            else
              resolve(response.data);
          } else {
            if (response?.data?.statusCode === 501) {
              reject(response.data.message);

            }
          }
        })
        .catch(function (error) {
          if (error.response.status == DEVELOPMENT_CONFIG.unAuthorized) {
            localStorage.clear();
            window.location.href = "/login";
          }

          else {
            reject(error.message);
          }
        });
    });
  },

  putRequest: function (url, data, returnResultDataOnly = false) {
    if (!returnResultDataOnly) returnResultDataOnly = false;
    const token = localStorage.getItem("token");
    var config = {
      method: "put",
      url: DEVELOPMENT_CONFIG.base_url + url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return new Promise((resolve, reject) => {
      axios(config)
        .then(function (response) {
          if (response.data.statusCode === DEVELOPMENT_CONFIG.statusCode) {
            if (returnResultDataOnly === true)
              resolve(response.data.resultData);
            else
              resolve(response.data);
          } else {
            reject(response.data.message);
          }
        })
        .catch(function (error) {
          if (error.response.status == DEVELOPMENT_CONFIG.unAuthorized) {
            localStorage.clear();
            window.location.href = "/login";
          }
          else if(error?.response?.data?.Message){
            reject(error?.response?.data?.Message);
          } else {
            reject(error.message);
          }
        });
    });
  },

}
